import { createContext, useContext, useEffect, useState } from "react";
import { getToken, papi, setToken } from "@/lib/pizzeria";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(getToken() ? null : false);

  useEffect(() => {
    if (getToken()) {
      papi.get("/auth/me").then(({ data }) => setUser(data.user || data)).catch(() => {
        setToken(null);
        setUser(false);
      });
    }
  }, []);

  const finish = (data) => {
    setToken(data.access_token || data.token);
    setUser(data.user);
    return data.user;
  };
  const login = (email, password) => papi.post("/auth/login", { email, password }).then(({ data }) => finish(data));
  const register = (body) => papi.post("/auth/register", body).then(({ data }) => finish(data));
  const logout = () => {
    setToken(null);
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, setUser, login, register, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
